module.exports = __webpack_public_path__ + "static/media/pastelfrango.81e91940.webp";